import React from "react";
import DealInbox from "../Components/Ambassador/Management/DealInbox";

const AmbassadorInboxPage: React.FC = () => <DealInbox mode="inbox" />;

export default AmbassadorInboxPage;
